import React, { 
  useContext, useEffect, useRef
} from 'react';
import keycloakService from './keycloak_service';
import useClientDetails from './utils/hooks/use_client_details';

interface WSContextProps {
}

const WSContext = React.createContext<WebSocket | undefined>(undefined)

export const useWSContext = () => useContext(WSContext);

export const WSProvider: React.FC<React.PropsWithChildren<WSContextProps>> = ({ children = [] }) => {
  const { clientDetails } = useClientDetails();
  const wsRef = useRef<WebSocket>();

  useEffect(() => {
    if (clientDetails?.areEventsEnabled || false) {
      return;
    } 

    if (wsRef.current && wsRef.current.readyState !== wsRef.current.CLOSING && wsRef.current?.readyState !== wsRef.current?.CLOSED) {
      return;
    }

    const url = `wss://${window.location.host}/v1/ws`
    const ws = new WebSocket(url);
    // eslint-disable-next-line no-console -- Temporarily disabled, should be removed when full handling is added.
    ws.onmessage = console.log;
    ws.onopen = function onopen() {
      ws.send(keycloakService.getToken());
    }

    wsRef.current = ws;
  });

  return (
    <WSContext.Provider value={wsRef.current}>
      { children }
    </WSContext.Provider>
  )
}
